let language = {
    STORE_PRODUCT_FILTER_STORE_STATUS_CLOSE:"Inactive",
    STORE_PRODUCT_FILTER_STORE_STATUS_ACTIVE:"Active",
    STORE_PRODUCT_FILTER_STORE_STATUS_DRAFT:"Draft",
    STORE_PRODUCT_FILTER_STORE_STATUS_CONNECTING:"Connecting",
    STORE_PRODUCT_FILTER_STORE_STATUS_CONNECTING_DES:"Your store is connecting, if there is no response for a long time, please refresh this page",
    STORE_PRODUCT_FILTER_STORE_STATUS_CONNECTED:"Connected",
    STORE_PRODUCT_FILTER_STORE_STATUS_CONNECTED_DES:"Connection succeeded",
    STORE_PRODUCT_FILTER_STORE_STATUS_UNEXPECTED_ERROR:"unexpected error",
    STORE_PRODUCT_FILTER_STORE_STATUS_UNEXPECTED_ERROR_DES1:"An unknown error occurred when connecting to your store. Please check the following: Ensure that your website address is correct and accessible on the Internet.",
    STORE_PRODUCT_FILTER_STORE_STATUS_UNEXPECTED_ERROR_DES2:"access to read and write permissions on your e-shop.",
    STORE_PRODUCT_FILTER_STORE_STATUS_CONNECT_FAILED:"connect failed",
    STORE_PRODUCT_FILTER_STORE_STATUS_CONNECT_FAILED_DES:"You can click this label to try to reconnect",
    STORE_PRODUCT_FILTER_STORE_STATUS_AUTH_FAILED:"authorization failed",
    STORE_PRODUCT_FILTER_STORE_STATUS_AUTH_FAILED_DES:"Please go to the \"setting\" of \"operation\" on the right to reauthorize",
    STORE_PRODUCT_FILTER_STORE_STATUS_INVALID_URL:"invalid url",
    STORE_PRODUCT_FILTER_STORE_STATUS_INVALID_URL_DES:"Please go to the \"setting\" of \"operation\" on the right to refill your url",
    STORE_PRODUCT_FILTER_STORE_STATUS_MISSING_AUTH:"missing authorization",
    STORE_PRODUCT_FILTER_STORE_STATUS_MISSING_AUTH_DES:"Please go to the \"setting\" of \"operation\" on the right to reauthorize",
    STORE_PRODUCT_FILTER_STORE_STATUS_INVALID_SHOP:"invalid shop",
    STORE_PRODUCT_FILTER_STORE_STATUS_INVALID_SHOP_DES:"Please make sure you have successfully registered a shop.",
    STORE_PRODUCT_FILTER_STORE_STATUS_INVALID_PLUGIN:"invalid plugin",
    STORE_PRODUCT_FILTER_STORE_STATUS_INVALID_PLUGIN_DES:"Please make sure you have installed our plugin in shopify"
};

export { language }